import ConfirmDlg from "@/components/popup/confirm-dialog/ConfirmDlg.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Loader from "@/components/loader/Loader.vue";
import AddTagsDialog from "./addTagsDialog/AddTagsDialog.vue";

export default {
  name: "TagManager",
  components: {
    ValidationObserver,
    ValidationProvider,
    AddTagsDialog,
    ConfirmDlg,
    Loader
  },
  data() {
    return {
      search: "",
      headers: [
        {
          text: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Name'],
          value: "name",
          sortable: false,
          width:'*'
        },
        {
          text: "",
          value: "id",
          sortable: false,
          width:200
        }
      ]
    }
  },
  async created() {
    await this.$store.dispatch("getTags");
    await this.$store.dispatch("getResidentsShortData");
  },
  computed: {
    currentFacility() {
      return this.$store.state.facilityModule.selectedFacility;
    },
    residents() {
      return this.$store.state.residentModule.residentsShortData;
    },
    tags() {
      return this.$store.state.tagsModule.tags
    }
  },
  methods: {
    editTags(row) {
      this.$refs.addTagsDialog.open(row);
    },
    async deleteTag(row) {
      const records = await this.$store.dispatch("isTagInUse", row.id) 

      const message = records?.length > 0? 
      this.$i18n.messages[this.$i18n.locale]['LifestyleProgramsSettings.TagWithDependencyQuestion'].replace('[records]', records.map(x=>x.name).join(', ')):
      this.$i18n.messages[this.$i18n.locale]['LifestyleProgramsSettings.DeleteTag'].replace('[name]', row.name)

      this.$refs.confirmationModal.open(null, message, false)
      .then(response => {
        if (response && response.agree) {
          this.$store.dispatch("deleteTag", row.id);
        }
      });
    },
    addTags() {
      this.$refs.addTagsDialog.open();
    }
  },

}